import React,{ Component } from "react";
import './index.less'
import Banner from "../compoonents/banner/index";
import LongBanner from  '../compoonents/longBanner/index'
import News from "../compoonents/news/index";
import News2 from "../compoonents/news2/index";
import Video from "../compoonents/video/index";
class Mobile extends Component{
    render() {
        return <div className='index_mobile'>
            <Banner />
            <div style={{width:'94%',margin:'auto'}}>
                <News length={8} list={[
                    <span><span className='iconfont icondongtai' /> 会议报道</span>,
                    <span><span className='iconfont icontongzhi3' /> 活动通知</span>
                ]} />
            </div>
            <LongBanner />
            <div style={{borderBottom:'15px solid rgb(245 247 247)'}}>
                <div style={{width:'94%',margin:'auto'}}>
                    <News length={8} list={[<span><span className='iconfont iconxiezuo' />地方协作组</span>]} />
                </div>
            </div>
            <div style={{borderBottom:'15px solid rgb(245 247 247)'}}>
                <div style={{width:'94%',margin:'auto'}}>
                    <News length={8} list={[<span><span className='iconfont iconyisheng' /> 专家门诊时间</span>]} />
                </div>
            </div>
            <div style={{borderBottom:'15px solid rgb(245 247 247)'}}>
                <div style={{width:'94%',margin:'auto'}}>
                    <News2 list={[<span><span className='iconfont iconzhinan' /> 指南/文献</span>,
                        <span><span className='iconfont iconzazhi' /> 期刊杂志</span>]} />
                </div>
            </div>
            <div style={{width:'94%',margin:'auto'}}>
                <Video Mobile={true} />
            </div>
        </div>
    }
}
export default Mobile